(function(module) {
try {
  module = angular.module('betosyswebapp');
} catch (e) {
  module = angular.module('betosyswebapp', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('components/dashboard/fmsVehicle/fmsVehicleWidgetEdit.tpl.html',
    '<div class="form-group"><label for="widgetTitle" translate="dashBoard.fleetManagement.vehicleList.noOfGridRows"></label><div><jqx-drop-down-list jqx-settings="noOfRowsettings" ng-model="noOfGridRows" jqx-on-change="noOfGridOnChange(event)" style="overflow: hidden!important;"></jqx-drop-down-list></div></div>');
}]);
})();



// WEBPACK FOOTER //
// ./.tmp/components/dashboard/fmsVehicle/fmsVehicleWidgetEdit.tpl.js